import { FC } from "react";
import { useParams } from "react-router-dom";

import { BookingEditFormDrawer } from "@ryde/layout";
import { useBookingsNavigation } from "@ryde/redux";
import { DrawerType, EditFormMode } from "@ryde/shared";

interface IBookingEdit {
  isAddRoute?: boolean;
}

export const BookingEdit: FC<IBookingEdit> = ({ isAddRoute }) => {
  const { id } = useParams<{ id: string }>();
  const { navigateBookingsGridOrCalendar } = useBookingsNavigation();

  const idOpen = Number(id) && !isAddRoute ? Number(id) : undefined;
  const idCopyFrom = Number(id) && isAddRoute ? Number(id) : undefined;
  return (
    <BookingEditFormDrawer
      type={DrawerType.BookingEditForm}
      mode={EditFormMode.CrudRoute}
      onCloseDrawer={navigateBookingsGridOrCalendar}
      id={idOpen}
      idCopyFrom={idCopyFrom}
    />
  );
};
